import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import CircleStyle from "ol/style/Circle";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Draw, Snap, Modify } from "ol/interaction";
import { Feature } from "ol";
import { addAOIFeature } from "../../../store/slices/aoiSlice";
import
{
  AOI_DRAWING_FEATURE_COLOR,
  AOI_DRAWING_FEATURE_STROKE_COLOR,
  AOI_DRAWING_FEATURE_STROKE_WIDTH,
  AOI_FEATURE_COLOR,
  AOI_FEATURE_KEY,
  AOI_FEATURE_STROKE_COLOR,
  AOI_FEATURE_STROKE_WIDTH,
  AOI_LAYER_ID,
  AOI_SOURCE_ID,
} from "../consts";
import type { Dispatch, UnknownAction } from "redux";
import { toLonLat } from "ol/proj";
import type { AOICoordinate, DrawAOIFeature, DrawAOIGeometry, DrawingAOIMode } from "../types";

export function createOLDrawingAOI(
  map: any,
  mode: DrawingAOIMode,
  editingFeatureId: string | null,
  features: DrawAOIFeature[],
  dispatch: Dispatch<UnknownAction> | any,
)
{
  let draw: any; // ol Draw
  let snap: any; // ol Snap
  //let modify: any; // ol Modify

  const source = new VectorSource();
  source.set("id", AOI_SOURCE_ID);
  const layer = new VectorLayer({ source });
  layer.set("id", AOI_LAYER_ID);

  map.addLayer(layer);

  const style = new Style({
    fill: new Fill({
      color: AOI_DRAWING_FEATURE_COLOR,
    }),
    stroke: new Stroke({
      color: AOI_DRAWING_FEATURE_STROKE_COLOR,
      lineDash: [10, 10],
      width: AOI_DRAWING_FEATURE_STROKE_WIDTH,
    }),
    image: new CircleStyle({
      radius: 5,
      stroke: new Stroke({
        color: AOI_DRAWING_FEATURE_STROKE_COLOR,
        width: AOI_DRAWING_FEATURE_STROKE_WIDTH,
      }),
      fill: new Fill({
        color: AOI_DRAWING_FEATURE_COLOR,
      }),
    }),
  });

  return {
    activate()
    {
      const snap = new Snap({ source: source });
      //const modify = new Modify({ source: source });
      draw = new Draw({
        source: source,
        type: "Polygon",
        style: style,
      });
      draw.on("drawend", (evt: { feature: Feature }) =>
      {
        evt?.feature.setStyle(
          new Style({
            fill: new Fill({ color: AOI_FEATURE_COLOR }),
            stroke: new Stroke({ color: AOI_FEATURE_STROKE_COLOR, width: AOI_FEATURE_STROKE_WIDTH }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({ color: AOI_FEATURE_COLOR }),
              stroke: new Stroke({ color: AOI_FEATURE_STROKE_COLOR, width: AOI_FEATURE_STROKE_WIDTH }),
            }),
          }),
        );

        const geom = (evt.feature as { getGeometry: () => unknown }).getGeometry();
        const newGeom = olGeomToDraw(geom, toLonLat);
        if (newGeom)
        {
          dispatch(
            addAOIFeature({
              id: evt?.feature?.getId()?.toString() || evt?.feature?.get("id") || `${AOI_FEATURE_KEY}-${crypto.randomUUID()}`,
              geometry: newGeom,
            }),
          );
        }
      });
      map.addInteraction(draw);
      map.addInteraction(snap);
      //map.addInteraction(modify);
    },

    deactivate()
    {
      if (draw)
      {
        map.removeInteraction(draw);
        map.removeInteraction(snap);
        //map.removeInteraction(modify);
      }
    },
  };
}

export function olGeomToDraw(geom: unknown, toLonLat: (c: number[]) => number[]): DrawAOIGeometry | null
{
  return {
    type: "Polygon",
    coordinates: (geom as { getCoordinates: () => number[][][] }).getCoordinates().map((r) => r.map((c) => toLonLat(c) as AOICoordinate)),
  };
}
